import { isRejectedWithValue } from '@reduxjs/toolkit'
import { onLogout } from '../redux/common.slice';
import Cookies from 'js-cookie';

export class AuthorizationError extends Error {
  constructor(message) {
    super(message)
    this.name = 'AuthorizationError'
  }
}

export const authenticationMiddleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        if (isRejectedWithValue(action)) {
          if (action.payload.status === 401) {
            dispatch(onLogout());
            localStorage.clear();
            Cookies.remove('token');

          }
        }
        return next(action)
      }
